import React from 'react'
import { toast as toastify, ToastOptions } from 'react-toastify'

import { CheckCircle, Info, Warning, WarningCircle } from 'phosphor-react'

import { Toast as ToastComponent } from 'Components/UI/_v2'

import { _ } from 'Services/I18n'

interface Params {
  label?: React.ReactNode
  text: React.ReactNode
  icon?: React.ReactNode
  footer?: React.ReactNode
}

const DEFAULT_OPTIONS: ToastOptions = {
  autoClose: 2500,
  closeOnClick: true,
  pauseOnHover: true,
}

const toast = {
  info: (params: Params, options: ToastOptions = DEFAULT_OPTIONS) => {
    toastify.info(
      <ToastComponent
        {...params}
        icon={params?.icon ? params.icon : <Info />}
        info
        label={params?.label ? params.label : _('toasts.labels.info')}
      />,
      options,
    )
  },

  warning: (params: Params, options: ToastOptions = DEFAULT_OPTIONS) => {
    toastify.warning(
      <ToastComponent
        {...params}
        icon={params?.icon ? params.icon : <Warning />}
        label={params?.label ? params.label : _('toasts.labels.warning')}
        warning
      />,
      options,
    )
  },

  error: (
    { label = _('toasts.labels.error'), ...rest }: Params,
    options: ToastOptions = DEFAULT_OPTIONS,
  ) => {
    toastify.error(
      <ToastComponent
        {...rest}
        danger
        icon={rest?.icon ? rest.icon : <WarningCircle />}
        label={label}
      />,
      options,
    )
  },

  success: (params: Params, options: ToastOptions = DEFAULT_OPTIONS) => {
    toastify.success(
      <ToastComponent
        {...params}
        icon={params?.icon ? params.icon : <CheckCircle />}
        label={params?.label ? params.label : _('toasts.labels.success')}
        success
      />,
      options,
    )
  },
}

export default toast
